'use strict';

var viewTop, viewBottom;

var updateViewPos = function() {
  viewTop = document.body.scrollTop;
  viewBottom = viewTop + window.innerHeight;
};

var isVisible = function(el) {
  var elTop = el.getBoundingClientRect().top + viewTop;
  var elBottom = elTop + el.offsetHeight;

  return (elBottom >= viewTop) && (elTop <= viewBottom);
};

var animateText = function() {
  var animatedEls = document.querySelectorAll('.animate-on-scroll');

  for (var i = 0; i < animatedEls.length; i++) {
    var el = animatedEls[i];

    if (isVisible(el, true)) {
      el.classList.add('animate-in');
    }
  }
};

var makeParallax = function() {
  var screenWidth = window.innerWidth;
  var parallaxEls = document.querySelectorAll('.parallax-back');

  for (var i = 0; i < parallaxEls.length; i++) {
    var el = parallaxEls[i];
    var elTop = el.getBoundingClientRect().top + viewTop;

    if (screenWidth >= 1200) {
      el.style.transform = 'translateY(' + ((viewTop - elTop) / 5) + 'px)';
    } else {
      el.style.transform = 'translateY(0)';
    }
  }

};

var initiateAnimations = function() {
  var handleAnimations = function() {
    updateViewPos();
    animateText();
    makeParallax();
  };

  document.addEventListener('scroll', handleAnimations);
  document.addEventListener('resize', handleAnimations);
};

var init = function() {
  return Promise.resolve()
    .then(updateViewPos)
    .then(initiateAnimations);
};

module.exports = {
  init: init
};
